// NotificationBar.jsx
import React from "react";

export default function NotificationBar({ message, onClose }) {
  if (!message) return null;

  return (
    <div style={styles.bar}>
      <span>{message}</span>
      <button onClick={onClose} style={styles.close}>✖</button>
    </div>
  );
}

const styles = {
  bar: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    backgroundColor: "#f9a8d4", // ชมพูพาสเทล
    color: "#4b5563", // เทาเข้ม
    padding: "12px 20px",
    textAlign: "center",
    fontWeight: "bold",
    zIndex: 9999,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    fontFamily: "'Noto Sans Thai', sans-serif",
  },
  close: {
    marginLeft: 16,
    background: "none",
    border: "none",
    color: "#4b5563",
    fontSize: "1rem",
    cursor: "pointer",
  },
};
